import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VueI18n from 'vue-i18n'
import id from 'vuetify/lib/locale/id'
import en from 'vuetify/lib/locale/en'

Vue.use(Vuetify)
Vue.use(VueI18n)

const messages = {
  id: {
    $vuetify: {
      ...id,
      login: "Masuk ke"
    },
  },
  en: {
    $vuetify: {
      ...en,
      login: "Login to"
    },
  },
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'id', // set locale
  messages, // set locale messages
})

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      light: {
        // e-Sign blue + DTD semantic colours (see src/css/tokens.css)
        primary: '#007DFE',   // e-Sign blue, color-primary
        secondary: '#002B81', // e-Sign navy, color-secondary
        success: '#2E885E',   // green-500
        error: '#D70000',     // red-700, color-error-interactive
        warning: '#C26900',   // orange-700
        info: '#2196D6',      // sky-500
        tertiary: '#2A6171',
        // named colours used in templates (color="red" etc.), mapped to the DTD palette
        orange: '#C26900',    // orange-700
        red: '#D70000',       // red-700, negative button
        green: '#2E885E',     // green-500
        blue: '#1E5BB8',      // blue-800
        brown: '#A67902',     // yellow-700
        header: '#FFFFFF',
        footer: '#FFFFFF',
        drawer: '#fff',
        icon_drawer: '#51A2A2',
        menu_drawer: '#16B3AC',
        submenu_drawer: '#D2E920',


      },
      dark: {
        // primary: '#022C43',
        primary: '#007DFE',
        secondary: '#053F5E',
        tertiary: '#115173',
        orange: '#F6D637',


        // for toolbar and card color template

        red: '#115173',
        green: '#115173',
        blue: '#115173',
        brown: '#115173',
        // header:'#000000',
        // footer:'#000000',
        // drawer: '#000000',
        drawer: '#363636',
        icon_drawer: '#51A2A2',
      }
    }
  },
  icons: {
    iconfont: 'mdi',
    iconfont: 'mdiSvg'
  }
})
